<div class="ct-dialog ct-data-dialog">
  <div class="ct-dialog-title">
      <span>Team members of</span><span>{{jiraSetting.settingName}}</span>
      <button class="ct-dialog-close" mat-dialog-close ctClickClose></button>
  </div>

  <button mat-raised-button class="ct-blue-button" (click)="loadAllProjects()">
    Update jira projects
  </button>

  <div class="ct-search-container">
      <div class="ct-grid-search-filter">
          <input class="ct-input-element" #gb placeholder="Search to add or remove teammates"
          [(ngModel)]="filterStr"
          (input)="onGlobalFilter($event.target.value)">
          <i class="ct-search-icon"></i>
      </div>
  </div>



  <div class="ct-grid" #grid>
      <div class="ct-popup-table-wrapper">
          <p-table #assignedTable class="ct-grid-container ct-grid-row-border ct-grid-blue"
                   [value]="assignedJiraProjects?.data"
                   scrollable="true" [sortField]="'jiraProjectName'"
                   [lazy]="true"
                   [loading]="!isAssingedProjects"
                   (onLazyLoad)="updateAssignedProjects($event)"
                   (onMoreContent)="updateAssignedProjects()">

              <ng-template pTemplate="header">
                  <tr>
                      <th pSortableColumn="jiraProjectName" [style]="{'width':'330px'}" class="ct-info-col">
                          {{AddssignedJiraProjects?.count}} Jira project name
                          <p-sortIcon field="jiraProjectName"></p-sortIcon>
                      </th>
                      <th pSortableColumn="projectName" [style]="{'width':'470px'}">
                          Project name
                          <p-sortIcon field="projectName"></p-sortIcon>
                      </th>
                  </tr>
              </ng-template>

              <ng-template pTemplate="body" let-jiraProject>
                  <tr>
                      <td class="ct-info-col">
                            {{jiraProject.jiraProjectName}}
                      </td>
                      <td>{{jiraProject.projectName}}</td>
                  </tr>
              </ng-template>
          </p-table>

          <p-table #notAssignTable class="ct-grid-container ct-grid-row-border"
                   [value]="notAssignedJiraProjects?.data"
                   scrollable="true" [sortField]="'key'"
                   [lazy]="true"
                   [loading]="!isNotAssingedProjects"
                   (onLazyLoad)="updateNotAssignedProjects($event)"
                   (onMoreContent)="updateNotAssignedProjects()">

              <ng-template pTemplate="header">
                  <tr>
                    <th pSortableColumn="name" [style]="{'width':'330px'}">
                      Name
                      <p-sortIcon field="name"></p-sortIcon>
                    </th>
                    <th pSortableColumn="key" [style]="{'width':'470px'}" class="ct-info-col">
                        Key
                        <p-sortIcon field="key"></p-sortIcon>
                    </th>
                  </tr>
              </ng-template>

              <ng-template pTemplate="body" let-jiraProject>
                  <tr>
                    <td class="ct-info-col">{{jiraProject.name}}</td>
                    <td>{{jiraProject.key}}</td>
                  </tr>
              </ng-template>
          </p-table>
      </div>
  </div>
</div>
